export const TOAST_MESSAGES_DELETE_TICKET = {
  DELETE_TICKET_ERROR: 'Error delete ticket, please try again',
  DELETE_TICKET_SUCCESS: 'Ticket deleted successfully!',
};

export const BANNER_TITLE = 'Please double-check before deleting. This action is permanent.';

export const DESCRIPTION = (
  <>
    Are you sure you want to delete this ticket? <br /> Once deleted, this ticket will be{' '}
    <strong className="font-bold">permanently removed</strong> and <strong>cannot be recovered</strong>.
  </>
);
